import {
  ConfirmationModal,
  ConfirmationModalProps,
} from '@/components/modals/ConfirmationModal/ConfirmationModal';

export function ConfirmDiscardChangesModal({
  isOpen,
  onClose,
}: Pick<ConfirmationModalProps, 'isOpen' | 'onClose'>) {
  return (
    <ConfirmationModal
      isOpen={isOpen}
      heading="Unsaved changes"
      cancelText="Leave"
      confirmText="Stay"
      cancelButtonProps={{ variant: 'destructive-primary' }}
      confirmButtonProps={{ variant: 'secondary' }}
      closeOnOutsideClick={false}
      onClose={(reason) => onClose(reason === 'cancel' ? 'confirm' : 'cancel')}
    >
      Are you sure you want to leave? Changes that you&apos;ve made will not be
      saved.
    </ConfirmationModal>
  );
}

export function ConfirmResolveDuplicatesModal({
  isOpen,
  onClose,
}: Pick<ConfirmationModalProps, 'isOpen' | 'onClose'>) {
  return (
    <ConfirmationModal
      isOpen={isOpen}
      heading="Unresolved duplicates"
      confirmText="Return to form"
      onClose={onClose}
      confirmationOnly
    >
      Please resolve before proceeding
    </ConfirmationModal>
  );
}
